//
// --- Types ---

export type EventNameKeyType = keyof typeof EVENT;
export type EventNameType = typeof EVENT[EventNameKeyType];

interface EventBusServiceEvent {
  callback?: () => void;
  data?: any;
  name: string;
  overridable?: boolean;
  persistent?: boolean;
  sender?: {
    eventBusService: unknown;
    id: string;
    type: string;
  };
  sendTo?: unknown;
  sendToSender?: boolean;
}

export interface GridAppWidgetResizedEvent extends EventBusServiceEvent {
  data: {
    id: number;
    name: string;
    parameters: {
      gridLayout: {
        h: number;
        w: number;
        x: number;
        y: number;
      };
    };
    statuses: ReadonlyArray<string>;
    type: string;
  };
  name: 'WidgetResized';
}

export interface GridAppWidgetStatusChangeEvent extends EventBusServiceEvent {
  data: {
    statuses: ReadonlyArray<string>;
    widgetId: number;
  };
}

export interface GridAppAddStatusToWidgetEvent extends GridAppWidgetStatusChangeEvent {
  name: 'AddStatusesToWidget';
}

export interface GridAppRemoveStatusFromWidgetEvent extends GridAppWidgetStatusChangeEvent {
  name: 'RemoveStatusesFromWidget';
}

//
// --- Event Constants ---

export const EVENT = {
  DISPLAY_CANCELABLE_MASKED_APP_DIALOG: 'supplier_search_displayCancelableMaskedAppDialog',
  DISPLAY_MASKED_APP_DIALOG: 'supplier_search_displayMaskedAppDialog',
  GRID_APP_ADD_STATUS_TO_WIDGET: 'AddStatusesToWidget',
  GRID_APP_REMOVE_STATUS_FROM_WIDGET: 'RemoveStatusesFromWidget',
  GRID_APP_WIDGET_RESIZED: 'WidgetResized',
  REFRESH_BID_TEAMS: 'supplier_search_refreshBidTeams',
  REFRESH_SUPPLIER_REQUESTS: 'supplier_search_refreshSupplierRequests',
  SHOW_BID_TEAM_PANEL_LOADING_MASK: 'supplier_search_showBidTeamsPanelLoadingMask'
} as const;
